import { renderGalleryEvents } from "./calendar/gallery-view";
import { renderTableEvents } from "./calendar/list-view";
import { calendarFilter } from "./calendar/filters";

calendarFilter((categoriesList) => {
    renderGalleryEvents(categoriesList);
    renderTableEvents(categoriesList);
});
